import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Position } from '@/types';
import { useGetPositionsQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchPositions<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Position> } & Omit<
  AutocompleteProps<Position, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetPositionsQueryProps = useAsyncSearch<Position, Multiple, DisableClearable, FreeSolo>(
    useGetPositionsQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetPositionsQueryProps} />;
}

export default SearchPositions;
